<template>
  <Modal v-model="addOrderTagsModal" width="600" :transfer="false" :mask-closable="false"
    :title="addOrderTagsTitle" @on-visible-change="addOrderTagsChange">
    <Form :model="addOrderTagsForm" ref="addOrderTagsForm" :label-width="90" @submit.native.prevent>
      <Row style="width: 95%">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="orderTagsType === 'tags'">
          <FormItem :label="$t('key1003225')" prop="ymsPackageTagId" :rules="tagTypeRules">
            <Select v-model="addOrderTagsForm.ymsPackageTagId" transfer>
              <Option v-for="item in orderLabelData" :key="item.ymsPackageTagId" :value="item.ymsPackageTagId">{{ item.tagName }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="labelName" prop="remark" :rules="remarksRules">
            <Input v-model.trim="addOrderTagsForm.remark" maxlength="200" show-word-limit
              type="textarea" :autosize="{minRows: 6, maxRows: 10}">
            </Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="addOrderTagsModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="addOrderTagsBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'addOrderTagsModal',
  mixins: [Mixin],
  props: {
    ymsOrderLabelData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      addOrderTagsModal: false,
      addOrderTagsForm: {
        ymsPackageTagId: null,
        remark: ''
      },
      orderTagsType: 'tags',
      addOrderTagsTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001443'),
      ymsPackageIdList: []
    };
  },
  computed: {
    orderLabelData() {
      return this.ymsOrderLabelData.filter((item) => {
        return item.ymsPackageTagId !== 'null';
      });
    },
    labelName() {
      return this.orderTagsType === 'tags' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004637') : '';
    },
    // 标签规则
    tagTypeRules() {
      return [
        {required: this.orderTagsType === 'tags', message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003233'), trigger: 'change'}
      ];
    },
    // 备注规则
    remarksRules() {
      return [
        {required: this.orderTagsType === 'remark', message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003710'), trigger: 'blur'}
      ];
    }
  },
  methods: {
    // 初始化数据
    initAddOrderTagsData(ymsPackageIdList, type) {
      let obj = {
        tags: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001443'),
        remark: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002015')
      };
      this.addOrderTagsTitle = obj[type];
      this.orderTagsType = type;
      this.ymsPackageIdList = ymsPackageIdList;
      this.addOrderTagsForm.ymsPackageTagId = this.orderLabelData.length > 0 ? this.orderLabelData[0].ymsPackageTagId : null;
      this.addOrderTagsModal = true;
    },
    // 保存
    addOrderTagsBtn() {
      let v = this;
      let params = {
        remark: v.addOrderTagsForm.remark,
        ymsPackageIds: v.ymsPackageIdList
      };
      if (v.orderTagsType === 'tags') {
        params.ymsPackageTagId = v.addOrderTagsForm.ymsPackageTagId;
      }
      v.$refs['addOrderTagsForm'].validate((valid) => {
        if (valid) {
          v.axios.post(api.post_ymsPackageInfo_addTagOrRemark, params, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((response) => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000194'));
              v.$emit('updateData', true);
              v.addOrderTagsModal = false;
            }
          });
        }
      });
    },
    // 监听弹窗
    addOrderTagsChange(value) {
      if (!value) {
        this.$refs['addOrderTagsForm'].resetFields();
        this.ymsPackageIdList = [];
      }
    }
  },
};
</script>

<style lang="less">

</style>
